import { get, merge } from 'lodash';
import { push } from 'react-router-redux';
import { updateUser, updateApplicant } from './../sync';
import { updateProfile } from './../sync/contacts';
import { updateCompany } from './../sync/companies';

import { logout } from './../sync/auth';

export function logIn(credentials) {
  return simpleIsoFetch => dispatch => {

    dispatch(updateUser({
      authFailed: false
    }));
    simpleIsoFetch.post({
      route: '/api/auth',
      body: credentials
    })
    .then(({body}) => {
      // Check Authentication was successful
      if (body.status !== 'success') {
        throw new Error('Authentication failed.'); // Auth failed. Short circuit chain.
      }

      return body;
    })
    .then(body =>
      // Get user roles from response body
      ({roles: get(body, 'data.items[1].roles', []), body})
    )
    .then(({roles, body}) => {
        // Save auth token to localStorage
        localStorage.setItem('token', body.data.items[0]);
        dispatch(updateUser(merge({loggedIn: true}, body.data.items[1])));

         if (~roles.indexOf('Client')) {
            dispatch(updateProfile(body.data.items[2].profile));
            dispatch(updateCompany({ company: body.data.items[2].company }));
         }else if(~roles.indexOf('Applicant')) {
            dispatch(updateProfile(body.data.items[2]));
            dispatch(updateApplicant({ applicantProfile: body.data.items[2] }));
        }else{
            dispatch(updateProfile(body.data.items[2]));
        }

    })
    .catch(err => {
      // console log unexpected
      // if(!err || err.status !== 400) {
      //   return console.error(err);
      // }

      // login failed
      return dispatch(updateUser({
        authFailed: true,
        loggedIn: false
      }));
    });
  };
}

export function logOut(body) {
  return simpleIsoFetch => dispatch => {
    // Clear token from localStorage
    localStorage.removeItem('token');
    // Clear user from store
    dispatch(logout());
    // Redirect to landing page
    // dispatch(push('/'));
    // Call server to wipe cookie.
    return simpleIsoFetch.get({
      route: '/api/auth/logout',
      body
    });
  };
}

export function currentUser(callback) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.get('/api/auth')
      .then(response => {
        if (response.status !== 200) {
          throw new Error('Current user not authenticated.')
        }

        return response;
      })
      .then(({body: {data: {items}}}) => items)
      .then(callback.success)
      .catch(callback.error);
  };
}

export function changePassword(body) {
  return simpleIsoFetch => dispatch =>
    simpleIsoFetch.post({
      route: '/api/auth/password',
      body
    })
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/auth.js